import * as Yup from 'yup'
import { getInitialState } from '../../../utils/formikUpdate'
import { fetchAllCountries } from '../../../services/countryService'

export const datasetFormik = async () => {
  let paisesOptions = {}
  try {
    const countries = await fetchAllCountries()
    countries.forEach(c => {
      paisesOptions[c.id] = c.nombre
    })
  } catch (err) {
    console.error('Error loading countries:', err)
  }

  const STEP1_FIELDS = [
    {
      x: 12,
      name: 'nombre',
      initvalue: '',
      label: 'Nombre de la Provincia *',
    },
    {
      x: 6,
      name: 'id_pais',
      initvalue: '',
      label: 'País *',
      options: paisesOptions,
    },
    {
      x: 6,
      name: 'habilitado',
      initvalue: 1,
      label: 'Estado',
      options: { 0: 'Desactivado', 1: 'Activado' },
    },
  ]

  const ITEMS_PROVINCE_FORMIK = [...STEP1_FIELDS]
  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_PROVINCE_FORMIK)

  const STEP1_VALIDATION = Yup.object().shape({
    nombre: Yup.string()
      .min(2, 'Mínimo 2 caracteres')
      .max(50, 'Máximo 50 caracteres')
      .required('Obligatorio'),
    id_pais: Yup.number()
      .required('Obligatorio')
      .typeError('Seleccione un país'),
  })

  const FORM_VALIDATION = STEP1_VALIDATION

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_PROVINCE_FORMIK,
    STEP1_FIELDS,
    STEP1_VALIDATION,
    FORM_VALIDATION,
  }
}
